export const DEFAULT_THEME_COLOR = '#533afd';

export const THEME_COLOR_STORAGE_KEY = 'zhiht_order_admin_theme_color';

export const THEME_COLOR_PRESETS = [
  '#533afd',
  '#4434d4',
  '#2e2b8c',
  '#665efd',
  '#b9b9f9',
  '#ea2261',
  '#f96bee',
  '#1c1e54',
  '#0d253d',
  '#15be53',
  '#9b6829',
] as const;
